export { default } from './ToggleSwitch.js';
//# sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/ToggleSwitch/index.js